interface ICommentaryUserPhotoProps {
    name: string;
    photo?: string;
}

function CommentaryUserPhoto({ name, photo }:ICommentaryUserPhotoProps) {
    const renderPhoto = () => {
        if (typeof photo === 'string') {
            return (
                <img alt={name} src={photo} />
            );
        }
        return name.split(' ').splice(0, 2).map((str) => str[0]).join('');
    };

    return (
        <div className="commentaries-list-item-user-photo-container">
            <div className="commentaries-list-item-user-photo d-flex justify-content-center align-items-center">
                {renderPhoto()}
            </div>
        </div>
    );
}

CommentaryUserPhoto.defaultProps = {
    photo: undefined,
};

export default CommentaryUserPhoto;
